export enum PermissionEnum {
    _None = 0,
    Documents = 1,
    Reports = 2,
    Administration = 3,
    Receipts = 11,
    DailyReports = 12,
    NonFiscals = 13,
    SalesStatement = 21,
    PrinterStatus = 22,
    QueueStatus = 23,
    Printers = 31,
    Shops = 32,
    PrintBasedOnItems = 211,
    AddPrinter = 311,
    EditPrinter = 312,
    AddShop = 321,
    EditShop = 322
}